<template>
  <div name="unitview" class="bg-white">
    <div name="innertopbar" class="flex pt-4 pb-6 mx-6 ">

          <div class="flex mb-2 w-1/2">
                    <div class="mr-2 w-14 h-14 p-1 bg-purple-600 rounded-full text-center "> 
                      <i class="fas fa-book text-2xl text-base text-purple-100 pt-3" title="Overview"></i></div>
                    
                    <div class="pt-2"> 
                       <h3 class="text-xl font-semibold"> {{ yearName }} -
        {{ course.name }}</h3>
                      <div
          class="text-xs font-bold text-purple-600 p-1 text-center mt-2 w-5/12 rounded-xl bg-purple-200 "
        >
          {{ categoryName }}
        </div>
                    </div>
                      
                    </div>


      <div
        class="text-black text-xl font-bold  pt-4 pl-2 capitalize text-left"
      >

      </div>

      <div class="text-right w-2/3 pr-4">
        <ul class="mt-1 md:w-11/12 md:ml-6 inline-block">
          <li class="inline-block">
            <dropdown
              v-if="classes.length > 0"
              :options="classDropdown"
              :css="'text-white'"
              :selected="selectedClass"
              v-on:updateOption="classSelect"
              class="bg-action-blue bg-opacity-75 hover:bg-opacity-50 w-48 text-center"
            ></dropdown>
          </li>

          <li class="inline-block mx-4 text-2xl text-gray-400">|</li>

          <li class="inline-block" @click="closeWindow()">
            <i class="fas fa-times close-icon text-1xl" title="Close"></i>
          </li>
        </ul>
      </div>
    </div>

    <div class="w-full mx-auto bg-white ">
      <div
        class="h-16 flex mx-6 overflow-x-auto border border-gray-200 content-center rounded-lg pl-4"
        ref="navList"
        v-if="lessonCount > 0"
      >
        <button
          @click="selectLesson()"
          type="button"
          class="flex-none focus:outline-none lesson-nav"
          v-bind:class="!hasValidLessonSelected ? 'selected-lesson' : ''"
        >
          <i class="fas fa-home text-1xl pr-2" title="Home"></i> Overview
        </button>
        <button
          @click="selectLesson(lesson)"
          type="button"
          class="flex-none focus:outline-none lesson-nav"
          v-bind:class="isLessonSelected(lesson) ? 'selected-lesson' : ''"
          v-for="lesson in orderedLessons"
          :key="lesson.id"
        >
          {{ lesson.name }}
        </button>

        <div ref="endPoint" class="opacity-0">&nbsp;</div>

        <button
          v-if="isOverflowing()"
          @click="scrollIntoView"
          class="header-subnav absolute bg-white h-12 right-0 pr-2 focus:outline-none"
        >
          <i class="fas fa-chevron-right text-xl text-gray-500 pt-2"></i>
        </button>
      </div>

      <div class="flex flex-col md:flex-row">
        <div
          i
          class="w-full h-screen overflow-y-scroll mt-4 pb-4 mx-2"
          id="infinite-list"
        >
          <div class="mt-4 w-full">
            <div v-if="errored" class="empty">
              <p>
                We are not able to retrieve this information at the moment,
                please try back later
              </p>
            </div>

            <div id="content-area" class="flex" v-else>
              <div style="width: 100%; text-align: center" v-if="loading">
                <i class="spinner fa fa-spinner fa-spin"></i>
              </div>

              <div class="w-2/3 border border-gray-200 rounded-lg mx-4">

                <LessonContent
                  v-if="hasValidLessonSelected"
                  :course="course"
                  :pupils="filteredPupils"
                  :lesson="selectedLesson"
                  :key="'content' + selectedLesson.id"
                >
                </LessonContent>

                <courseOverview
                  v-else
                  :course="course"
                  :lessons="lessons"
                  @showLesson="selectLesson"
                  @showAttendance="selectLessonWithAttendance"
                  @showEvidence="selectLessonWithEvidence"
                >
                </courseOverview>

                <p v-if="lessonCount === 0">
                  The selected unit has no lesson plans available. Please select
                  a different unit of work.
                </p>
              </div>

              <div class="w-1/3">
                <UnitSideBar
       :lesson="selectedLesson"
       :course="course"
       @assessment="openAssessment"
      @resources="openResources"
      @attendance="openAttendance"
      @feedback="openFeedback"
      @wellbeing="openPupilVoice"
      @outcomes="openOutcomes"
      @evidence="openEvidence"
      @help="openHelp"
      @files="openFiles"
    />
              </div>
            </div>



            <ModalSlide
              :show="showResourcesModal"
              @closeModal="showResourcesModal = false"
            >
              <template v-slot:header-icon>
                <i class="fas fa-folder"></i>
              </template>
              <template v-slot:header-title> Unit Files & Resources </template>
              <template v-slot:body>
                <UnitFileList
                  :course="course"
                  :key="'files' + course.id"
                ></UnitFileList>
              </template>
            </ModalSlide>

     <ModalSlide v-if="hasValidLessonSelected"
              :show="showLessonFilesModal"
              @closeModal="showLessonFilesModal = false"
            >
              <template v-slot:header-icon>
                <i class="fas fa-folder"></i>
              </template>
              <template v-slot:header-title> Lesson Files </template>
              <template v-slot:body>
                <UnitFileList
                  :course="course"
                  :lesson="selectedLesson"
                  :key="'files' + selectedLesson.id"
                ></UnitFileList>
              </template>
            </ModalSlide>



                 <ModalSlide v-if="hasValidLessonSelected"
      :show="showAttendanceModal"
      :cssWidth="'md:w-6/12'"
      @closeModal="showAttendanceModal = false"
    >
      <template v-slot:header-icon>
        <i class="fas fa-calendar-alt"></i>
      </template>
      <template v-slot:header-title> {{ selectedLesson.name }} Attendance </template>
      <template v-slot:body>
        <Attendance
          :lesson="selectedLesson"
          :key="'attendance' + selectedLesson.id"
          :pupils="filteredPupils"
        ></Attendance>
      </template>
    </ModalSlide>

    <ModalSlide  v-if="hasValidLessonSelected" :show="showPostsModal" @closeModal="showPostsModal = false">
      <template v-slot:header-icon>
        <i class="fas fa-comment-alt"></i>
      </template>
      <template v-slot:header-title>
        {{ selectedLesson.name }} Notes / Feedback
      </template>
      <template v-slot:body>
        <LessonPosts :lesson="selectedLesson" :key="'posts' + selectedLesson.id"></LessonPosts>
      </template>
    </ModalSlide>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const courseOverview = () =>
  import("@/components/curriculum/TheCourseOverview.vue");

const modalfile = () => import("@/components/ModalFile.vue");

const LessonContent = () => import("@/components/curriculum/TheLessonView.vue");

const dropdown = () => import("@/components/Dropdown.vue");
const UnitFileList = () => import("@/components/curriculum/TheUnitFileList");
const ModalSlide = () => import("@/components/ModalSlide.vue");
const UnitSideBar = () => import("@/components/curriculum/unit_view_helpers/TheUnitSideBar");
const LessonPosts = () => import("@/components/curriculum/LessonPosts.vue");
const Attendance = () =>
  import("@/components/curriculum/TheLessonAttendance.vue");

import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { PupilService } from "@/services/pupil.service";

import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";

export default {
  name: "unitview",
  mixins: [yearGroupMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    lessonCount() {
      return this.lessons.length;
    },
    componentLoaded() {
      return this.lessons.length > 0;
    },
    orderedLessons() {
      return _.orderBy(this.lessons, ["order", "name"]);
    },
    hasValidLessonSelected() {
      return this.selectedLesson != undefined;
    },
    classDropdown() {
      var results = [...this.classes];
      results = [{ id: 0, name: "Select a class" }].concat(results);
      this.selectedClass = results[0];
      return results;
    },
    filteredPupils() {
      var vm = this;
      let classChosen = vm.selectedClass;

      if (classChosen.id === 0) {
        return _.orderBy(vm.pupils, ["name", "yeargroup", "class"]);
      } else {
        var filtered = vm.pupils.filter(function (pupil) {
          return pupil.inclass === classChosen.name;
        });

        return _.orderBy(filtered, ["name", "yeargroup", "class"]);
      }
    },
    classIsSelected() {
      return this.selectedClass.id > 0;
    },
    year() {
      return this.years
        .filter((year) => {
          return this.course.year_id === year.id;
        })
        .shift();
    },
    yearName() {
      let result = this.year;
      return result.name;
    },
    categoryName() {
      if (this.course === undefined) {
        return "";
      }
      return this.course.category.name;
    },
    categoryColor() {
      if (this.course != undefined) {
        return "#" + this.course.category.color_hex;
      }
    },
  },
  data() {
    return {
      course: this.$store.getters.unit,
      loading: true,
      errored: false,
      lessons: [],
      selectedLesson: undefined,
      showDocuments: false,
      pupils: [],
      classes: [],
      selectedClass: {},
      showResourcesModal: false,
      showPostsModal: false,
      showAttendanceModal: false,
      showLessonFilesModal: false
    };
  },
  created() {
    this.loading = true;
    this.fetchData();

    PupilService.getClasses()
      .then((response) => this.buildClassList(response.data.data))
      .catch((err) => {
        console.log("classes " + err);
        this.errored = true;
      });

    this.fetchPupils();
  },
  mounted() {},
  methods: {
    fetchData() {
      SchoolService.getAll("courses/" + this.course.id + "/lessons")
        .then((response) => this.buildLessonList(response.data.data))
        .catch((err) => {
          console.log("Lessons " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildLessonList(data) {
      this.lessons = data;
    },
    fetchPupils() {
      PupilService.getAll()
        .then((response) => this.buildPupilList(response.data.data))
        .catch((err) => {
          console.log("Pupils " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildPupilList(data) {
      this.pupils = data;
    },
    buildClassList(data) {
      this.classes = data.map(function (item, index) {
        return { id: index + 1, name: item };
      });
    },
    closeWindow() {
      this.$router.push("/planning");
      window.scrollTo(0, 0);
    },
    print() {
      this.$htmlToPaper("printMe");
      //window.print();
      //   var newWindow = window.open();
      //   newWindow.document.write(document.getElementById("output").innerHTML);
      //   newWindow.print();
    },
    openResources() {
      this.showResourcesModal = true;
    },
    openAttendance() {
      this.showAttendanceModal = true;
    },
    openFeedback() {
      this.showPostsModal = true;
    },
    classSelect(value) {
      this.selectedClass = value;
    },
    selectLesson(value) {
      this.selectedLesson = value;
      this.$store.commit("setLesson", value);
    },
    selectLessonWithAttendance(value) {
      this.selectLesson(value);
    },
    selectLessonWithEvidence(value) {
      this.selectLesson(value);
      this.showEvidence();
    },
    isLessonSelected(lesson) {
      return (
        this.selectedLesson != undefined && this.selectedLesson.id === lesson.id
      );
    },
    isOverflowing() {
      var element = this.$refs.navList;

      if (element != undefined) {
        return element.offsetWidth < element.scrollWidth;
      }
    },
    scrollIntoView() {
      this.$refs["endPoint"].scrollIntoView({ behavior: "smooth" });
    },

    openPupilVoice: function () {
      this.$router.push({ name: 'UnitWellbeing', params: {course: this.course, pupils: this.filteredPupils }})
    },

    openOutcomes: function () {
      this.$router.push({ name: 'UnitOutcomes', params: {course: this.course, pupils: this.filteredPupils }})
    },
    openAssessment() {
      this.$router.push({name: 'UnitAssessment', params: {course: this.course, pupils: this.filteredPupils, classSelected: this.classIsSelected }})
    },
    openEvidence() {
      this.$router.push({name: 'LessonEvidence', params: {course: this.course, selectedClass: this.selectedClass, lesson: this.selectedLesson, lessons: this.lessons, classes: this.classes, pupils: this.filteredPupils}})
    },
    openHelp: function () {
         let url = "https://primarypepassport.co.uk/faqs/"
        window.open(url, '_blank', 'noreferrer');
        return
    },
    openFiles() {
       this.showLessonFilesModal = true;
    }
  },
  components: {
    modalfile,
    dropdown,
    courseOverview,
    UnitFileList,
    LessonContent,
    ModalSlide,
    UnitSideBar,
    LessonPosts,
    Attendance
  },
};
</script>

<style scoped>
.side-list-item {
  @apply p-4 px-2 mt-3 ml-4 mb-2 w-10/12 rounded-md font-medium cursor-pointer text-xs font-semibold;
}

.selected {
  @apply bg-white border-white;
}

.lesson-nav {
  @apply bg-gray-200 text-gray-700 rounded-xl my-2 px-4  mr-3 font-semibold text-xs;
}

.selected-lesson {
  @apply bg-purple-600 text-white font-bold;
}

.selected-lesson i {
  @apply text-white;
}

.tools {
   @apply pt-2;
}

.tools li {
    @apply border border-gray-100 rounded p-4 mb-2;
}

.tools li i {
   @apply text-2xl;
}


</style>
